const columns = [
  {
    title: 'Rank',
    dataIndex: 'placing',
    key: 'placing',
    width: '35px',
    sorter: (a, b) => a.placing - b.placing,
    defaultSortOrder: 'ascend'
  },
  {
    title: 'Points',
    dataIndex: 'battlePoints',
    key: 'battlePoints',
    width: '35px',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: '75px',
    sorter: (a, b) => a.name.localeCompare(b.name),
    render: (text, record) => {
      return record.name === 'Netherlands' ? <b>{record.name} </b> : record.name;
    },
  },
  {
    title: 'Captain',
    dataIndex: 'captain',
    key: 'captain',
    width: '125px',
    render: (text, record) => {
      return `${record.captain.firstName} ${record.captain.lastName}`;
    },
  },
];

export { columns };
